export default __webpack_public_path__ + "static/media/search-icon.877032f0.svg";